import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  key: 0
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_b_button = _resolveComponent("b-button");
  const _component_Loading = _resolveComponent("Loading");
  const _component_b_card_header = _resolveComponent("b-card-header");
  const _component_SubscriptionTypeInfo = _resolveComponent("SubscriptionTypeInfo");
  const _component_b_card_text = _resolveComponent("b-card-text");
  const _component_b_card = _resolveComponent("b-card");
  const _component_Breakdown = _resolveComponent("Breakdown");
  const _component_SelectType = _resolveComponent("SelectType");
  const _component_DiscountCode = _resolveComponent("DiscountCode");
  const _component_b_col = _resolveComponent("b-col");
  const _component_b_row = _resolveComponent("b-row");
  const _component_BillingList = _resolveComponent("BillingList");
  const _component_b_modal = _resolveComponent("b-modal");
  const _component_ChangeConfirm = _resolveComponent("ChangeConfirm");
  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_b_button, {
    variant: "success",
    type: "button",
    onClick: _cache[0] || (_cache[0] = _withModifiers($event => $data.openModal = true, ["prevent"]))
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(!$props.subscription || !$props.subscription.current ? 'Choose' : 'Switch My') + " Subscription ", 1)], undefined, true),
    _: 1
  }), _createVNode(_component_b_modal, {
    id: "subscription-change-modal",
    modelValue: $data.openModal,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.openModal = $event),
    "no-close-on-backdrop": "",
    "no-close-on-esc": "",
    title: "Change My Subscription",
    "ok-title": "Change Subscription",
    "ok-variant": "success",
    "ok-disabled": $data.loading || !$options.isValid,
    size: "xl",
    onOk: $options.confirmChange,
    onShow: _cache[2] || (_cache[2] = $event => $options.init())
  }, {
    default: _withCtx(() => [_createVNode(_component_Loading, {
      loading: $data.loading
    }, null, 8, ["loading"]), !$data.loading ? (_openBlock(), _createElementBlock("div", _hoisted_1, [$props.subscriptiontype && $props.subscriptiontype.id ? (_openBlock(), _createBlock(_component_b_card, {
      key: 0,
      "no-body": ""
    }, {
      default: _withCtx(() => [_createVNode(_component_b_card_header, null, {
        default: _withCtx(() => [...(_cache[5] || (_cache[5] = [_createElementVNode("h4", {
          class: "m-0"
        }, "New Subscription Info:", -1)]))], undefined, true),
        _: 1
      }), _createVNode(_component_b_card_text, {
        class: "m-3"
      }, {
        default: _withCtx(() => [_createVNode(_component_SubscriptionTypeInfo, {
          subscriptiontype: $props.subscriptiontype
        }, null, 8, ["subscriptiontype"])], undefined, true),
        _: 1
      })], undefined, true),
      _: 1
    })) : _createCommentVNode("", true), _createVNode(_component_Breakdown, {
      subscription: $data.newsubscription,
      discount: $data.discount,
      loading: $data.calculating,
      class: "mt-3"
    }, null, 8, ["subscription", "discount", "loading"]), !$props.subscriptiontype || !$props.subscriptiontype.id ? (_openBlock(), _createBlock(_component_SelectType, {
      key: 1,
      types: _ctx.subscriptiontypes,
      selected: $props.subscriptiontype,
      onSelect: $options.setSubscriptionType
    }, null, 8, ["types", "selected", "onSelect"])) : _createCommentVNode("", true), ($options.amountDue > 0 || $data.discount) && $props.subscriptiontype && $props.subscriptiontype.id ? (_openBlock(), _createBlock(_component_DiscountCode, {
      key: 2,
      discount: $data.discount,
      subscriptiontype_id: $props.subscriptiontype.id,
      balance: $options.amountDue,
      class: "mt-3",
      onDiscountApplied: $options.applyDiscount
    }, null, 8, ["discount", "subscriptiontype_id", "balance", "onDiscountApplied"])) : _createCommentVNode("", true), _createVNode(_component_b_row, {
      class: "my-3 mx-1"
    }, {
      default: _withCtx(() => [_createVNode(_component_b_col, {
        class: _normalizeClass(["alert p-3", $options.amountDue > 0 ? 'alert-danger' : 'alert-success'])
      }, {
        default: _withCtx(() => [_createElementVNode("h3", null, "Amount Due: " + _toDisplayString($options.amountDueFormatted), 1)], undefined, true),
        _: 1
      }, 8, ["class"])], undefined, true),
      _: 1
    }), $options.amountDue > 0 ? (_openBlock(), _createBlock(_component_b_card, {
      key: 3
    }, {
      default: _withCtx(() => [_createVNode(_component_BillingList, {
        states: $props.states,
        countries: $props.countries,
        selected: $data.billing,
        onSelect: $options.setBilling
      }, null, 8, ["states", "countries", "selected", "onSelect"])], undefined, true),
      _: 1
    })) : _createCommentVNode("", true)])) : _createCommentVNode("", true)], undefined, true),
    _: 1
  }, 8, ["modelValue", "ok-disabled", "onOk"]), $data.newsubscription && $data.confirm ? (_openBlock(), _createBlock(_component_ChangeConfirm, {
    key: 0,
    open: $data.openConfirm,
    subscription: $data.newsubscription,
    onRefresh: _cache[3] || (_cache[3] = $event => _ctx.$emit('refresh')),
    onClose: _cache[4] || (_cache[4] = $event => $data.openConfirm = false)
  }, null, 8, ["open", "subscription"])) : _createCommentVNode("", true)]);
}